<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.youZanSignDateVerifiedList.push"
    :is-show-search-input="true"
    search-placeholder="输入订单号、券码、标题等"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="100px"/>

    <v-column-avatar label="核销员"/>
    <el-table-column label="有赞订单号" prop="order_number"/>
    <el-table-column label="有赞券码" prop="ticket_code" width="130px"/>
    <el-table-column label="商品封面">
      <template v-slot="{ row }">
        <v-img class="table-cover" :value="row.cover"/>
      </template>
    </el-table-column>
    <el-table-column label="标题关键词" prop="title"/>
    <el-table-column label="副标题关键词" prop="title_sub"/>
    <el-table-column label="商品单价" prop="price"/>
    <el-table-column label="购买数量" prop="num"/>
    <el-table-column label="实际付款" prop="real_payment"/>
    <el-table-column label="买家留言" prop="buyer_message"/>
    <el-table-column label="卖家留言" prop="order_remark"/>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`you-zan-sign-date-verified-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>核销员</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>有赞订单号</span>
              <span>{{ v.order_number }}</span>
            </div>
            <div class="list-item-detail">
              <span>有赞券码</span>
              <span>{{ v.ticket_code }}</span>
            </div>
            <div class="list-item-detail">
              <span>商品封面</span>
              <v-img class="table-cover" :value="v.cover"/>
            </div>
            <div class="list-item-detail">
              <span>标题关键词</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>副标题关键词</span>
              <span>{{ v.title_sub }}</span>
            </div>
            <div class="list-item-detail">
              <span>商品单价</span>
              <span>{{ v.price }}</span>
            </div>
            <div class="list-item-detail">
              <span>购买数量</span>
              <span>{{ v.num }}</span>
            </div>
            <div class="list-item-detail">
              <span>实际付款</span>
              <span>{{ v.real_payment }}</span>
            </div>
            <div class="list-item-detail">
              <span>买家留言</span>
              <span>{{ v.buyer_message }}</span>
            </div>
            <div class="list-item-detail">
              <span>卖家留言</span>
              <span>{{ v.order_remark }}</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getVerifiedRecords } from '@/api/you-zan-sign-date';

export default {
  name: RouteConfig.youZanSignDateVerifiedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await getVerifiedRecords(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
